/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketing.discovery.rpc.MarketingDiscoveryService
 */

export const createAssetRpc = {
  serviceName: 'com.hubspot.marketing.discovery.rpc.MarketingDiscoveryService',
  rpcName: 'createAsset',
  auth: 'app',
  fingerprint: '8rxytsHuLFiTtKyVpXnk_PfFQA78kQCj',
  na1Only: false
};
export const getFlowWithTasksRpc = {
  serviceName: 'com.hubspot.marketing.discovery.rpc.MarketingDiscoveryService',
  rpcName: 'getFlowWithTasks',
  auth: 'app',
  fingerprint: '0qQWQ0HL0fZYSnf3j3Tq5_fFQA78kQCj',
  na1Only: false
};
export const updateTaskStatusRpc = {
  serviceName: 'com.hubspot.marketing.discovery.rpc.MarketingDiscoveryService',
  rpcName: 'updateTaskStatus',
  auth: 'app',
  fingerprint: 'SKlyGvGPZydLoCGf1G_i-PfFQA78kQCj',
  na1Only: false
};
export const deleteFlowRpc = {
  serviceName: 'com.hubspot.marketing.discovery.rpc.MarketingDiscoveryService',
  rpcName: 'deleteFlow',
  auth: 'app',
  fingerprint: 'WdnJ-Gc47Po184kUDfelXvfFQA78kQCj',
  na1Only: false
};